import { render } from "./DomainConfig.vue?vue&type=template&id=fdae4a10&scoped=true&lang=pug"
import script from "./DomainConfig.vue?vue&type=script&lang=js"
export * from "./DomainConfig.vue?vue&type=script&lang=js"

import "./DomainConfig.vue?vue&type=style&index=0&id=fdae4a10&lang=scss"
import "./DomainConfig.vue?vue&type=style&index=1&id=fdae4a10&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdae4a10"]])

export default __exports__